import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../../../../environments/environment';
import { WindowRef } from '../../services/window-ref/window-ref.service';

@Injectable({
  providedIn: 'root'
})
export class AuthValidator {

  /**
   * Class constructor
   *
   * @param _cookieService
   */
  constructor(
    private _cookieService: CookieService,
    private _windowRef: WindowRef
  ) {}

  /**
   * Verifies if the guest is authenticated
   *
   * @returns {boolean}
   */
  public verifyAuthCookies(): boolean {
    return !environment.useLoginGuard || this._cookieService.check('pep_jwt_token');
  }

  /**
   * @desc Handle Guest Login
   * @returns
   */
  public handleGuestLogin() {
    const profileAuthenticator = this._getProfileAuthenticator();

    let guestTokenResolve;
    let guestTokenReject;
    const guestTokenPromise = new Promise((resolve, reject) => {
      guestTokenResolve = resolve;
      guestTokenReject = reject;
    });

    this._handleLoginAction(guestTokenResolve);

    // handle modal close without logging in
    profileAuthenticator.did.on('close', () => {
      profileAuthenticator.getLoggedInStatus().then(result => {
        // login/reauth modal closed without logging in
        if (!result) {
          guestTokenResolve(false);
        }
      });
    });

    // launch oneId modal
    profileAuthenticator.getLoggedInStatus().then(result => {
      if (result) {
        profileAuthenticator.getGuest().then(guestResult => {
          guestTokenResolve(guestResult.token.swid,);
        });
      } else {
        profileAuthenticator.launchLogin();
      }
    });

    return guestTokenPromise;
  }

  /**
   * @desc Get Profile Authenticator
   * @returns
   */
  private _getProfileAuthenticator() {
    return this._windowRef.nativeWindow.PEP.PROFILE_AUTH;
  }

  /**
   * @desc Handle Login Action
   * @param {any} refreshGuestTokenResolve
   */
  private _handleLoginAction(guestTokenResolve) {
    const profileAuthenticator = this._getProfileAuthenticator();
    // listen on login and reauth event
    ['login', 'reauth'].forEach(didEvent => {
      profileAuthenticator.did.on(didEvent, (guestResult) => {
        guestTokenResolve(guestResult.token.swid);
      });
    });
  }
}
